import React from "react";

// Branded "please stand by" card shown instead of a dead/black frame.
export function FailoverSlate({ note = "We're restoring your 24/7 forecast. Please stand by." }) {
  return (
    <div
      data-testid="failover-slate"
      className="fixed inset-0 z-[200] flex flex-col items-center justify-center overflow-hidden text-white"
      style={{ background: "linear-gradient(160deg,#0a1b35 0%,#071527 60%,#050f1f 100%)" }}
    >
      <div
        className="pointer-events-none absolute inset-0 opacity-100"
        style={{ backgroundImage: "repeating-linear-gradient(135deg, rgba(255,255,255,.04) 0 2px, transparent 2px 12px)" }}
      />
      <div className="relative flex flex-col items-center px-8 text-center">
        <img src="/gwn-logo.png" alt="GAWX" style={{ width: "clamp(70px,9vw,130px)" }} className="drop-shadow-[0_6px_20px_rgba(0,0,0,0.6)]" />
        <div className="mt-5 font-oswald font-bold uppercase tracking-[0.42em] text-[#ffd60a]" style={{ fontSize: "clamp(11px,1.3vw,18px)" }}>
          Georgia Weather Network
        </div>
        <h1 className="mt-4 font-oswald font-black uppercase leading-none" style={{ fontSize: "clamp(40px,7vw,120px)" }}>
          Technical Difficulties
        </h1>
        <p className="mt-5 max-w-[40ch] font-oswald font-light text-[#c9d6ea]" style={{ fontSize: "clamp(14px,1.8vw,30px)" }}>
          {note}
        </p>
        <div className="mt-8 flex items-center gap-3">
          {[0, 1, 2].map((i) => (
            <span key={i} className="inline-block rounded-full bg-[#ffd60a]" style={{ width: "clamp(8px,0.9vw,14px)", height: "clamp(8px,0.9vw,14px)", animation: `slatePulse 1.2s ${i * 0.2}s infinite ease-in-out` }} />
          ))}
        </div>
      </div>
      <div className="absolute bottom-8 flex items-center gap-3 font-oswald uppercase tracking-[0.2em] text-[#9fb2cc]" style={{ fontSize: "clamp(10px,1.1vw,15px)" }}>
        <span className="inline-block h-2 w-2 rounded-full bg-[#ff3b30]" style={{ animation: "slatePulse 1.4s infinite ease-in-out" }} /> Live · 24/7 · Standing By
      </div>
      <style>{`@keyframes slatePulse{0%,100%{opacity:.25;transform:scale(.85)}50%{opacity:1;transform:scale(1)}}`}</style>
    </div>
  );
}

// Catches a crashing slide/render and shows the slate; auto-reloads the encoder as a last resort.
export class BroadcastErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
    this._timer = null;
  }
  static getDerivedStateFromError() {
    return { hasError: true };
  }
  componentDidCatch() {
    if (this.props.autoReload) {
      this._timer = setTimeout(() => window.location.reload(), 8000);
    }
  }
  componentWillUnmount() {
    if (this._timer) clearTimeout(this._timer);
  }
  render() {
    if (this.state.hasError) return <FailoverSlate note="Recovering the broadcast…" />;
    return this.props.children;
  }
}
